import Link from "@/components/AppLink";
import { getDashboardPathUrl } from "@/config/dashboardOrigin";

const Banner = () => {
  return (
    <section className="banner-section inner-banner index-5">
      <div className="overlay">
        <div className="banner-content pb-120">
          <div className="container">
            <div className="row">
              <div className="col-lg-7 col-md-10">
                <div className="main-content">
                  <h1>Auto-convert freelance earnings to crypto</h1>
                  <p className="xxlr">
                    Sweep settled balances into BTC, ETH, or stablecoins at live
                    market prices—perfect for contractors who want digital
                    treasury exposure without a separate exchange account.
                  </p>
                  <Link href={getDashboardPathUrl("/register-2")} className="cmn-btn">
                    Get Strart Now
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="illu-area"></div>
    </section>
  );
};

export default Banner;
